function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1664",
  "data-name": "Group 1664",
  transform: "translate(-329.289 -21.801)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1",
  "data-name": "Group 1",
  transform: "translate(329.289 21.801)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2",
  "data-name": "Path 2",
  d: "M250.447,85.36a.5.5,0,0,1-.5-.53.531.531,0,0,1,.53-.53H270.17a.53.53,0,1,1,0,1.06Z",
  transform: "translate(-249.952 -70.279)",
  fill: "#f0f0f0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3",
  "data-name": "Path 3",
  d: "M262.883,60.46a.53.53,0,1,1,0-1.06h15.3a.53.53,0,0,1,0,1.06Z",
  transform: "translate(-257.97 -52.407)",
  fill: "#f0f0f0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4",
  "data-name": "Path 4",
  d: "M250.447,35.66a.5.5,0,0,1-.5-.53.531.531,0,0,1,.53-.53H270.17a.53.53,0,1,1,0,1.06Z",
  transform: "translate(-249.952 -34.6)",
  fill: "#f0f0f0"
})));

var SvgBar = function SvgBar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.749,
    height: 15.081,
    viewBox: "0 0 20.749 15.081",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bar.22ab5a8d.svg";
export { ForwardRef as ReactComponent };